/* eslint-disable max-len */
export default {
    threats: {
        excerpt: {
            title: 'Sind Sie sich unsicher, ob Ihre digitalen Ressourcen und Anwendungen Unterstützung im Bereich Cyber-Sicherheit benötigen?',
            list: [
                'Warum ist das Risiko eines Angriffs auf Ihre Daten so groß?',
                'Was genau verliert man im Falle eines erfolgreichen Angriffs?',
                'Warum kann Sie der Diebstahl Ihrer Daten bis zu 4% Ihres Jahresumsatzes kosten?',
                'Welche Tätigkeiten und Technologien garantieren Ihnen volle Sicherheit?'
            ],
            button: 'Finden Sie es heraus'
        },
        content: {
            title: 'Sind die Ressourcen Ihres Unternehmens sicher?',
            description: 'Die Zahl der Angriffe auf die IT-Infrastruktur in Unternehmen und der Datendiebstähle ist in den letzten Jahren in einem alarmierenden Tempo gewachsen.',
            button: 'VIDEO ANSEHEN'
        }
    },
    offer: {
        excerpt: {
            title: 'Warum sollte Lemlock Ihr Partner in Sachen Cyber-Sicherheit sein?',
            list: [
                'Warum erfordert eine umfassende Sicherheit  einen interdisziplinären Ansatz?',
                'Welche Lösungen bietet Lemlock?',
                'Wie kann man den Bericht vor Informationen enthaltenden Leckagen schützen?',
                'Wie weisen Sie nach, dass Ihre Daten gut geschützt sind?'
            ],
            button: 'Angebot',
            button_pricing: 'Pricing'
        },
        content: {
            title: 'Sichern Sie Ihre Anwendungen und digitalen Ressourcen.',
            description: 'Der Schutz von Unternehmensressourcen ist eine Herausforderung, für die Wissen und Handlungen in den Bereichen Recht und Technologie gefordert sind.',
            button: 'Angebot'
        }
    },
    popup: {
        text: 'Haben Sie den Verdacht, dass Ihre Organisation gehackt wurde? Kontaktieren Sie uns sofort!',
        link: 'https://www.lemlock.de/verfahren-bei-cyberangriffen/'
    }
};



// WEBPACK FOOTER //
// ./src/i18n/de/home.js